import { MemberRole, MemberScimStatus, MemberStatus, PrincipalProvider, } from '@lucidlink/dto/validation';
export const toMemberViewModel = (data) => ({
    ...data,
    isOwner: data.role === MemberRole.OWNER,
    isAdmin: data.role === MemberRole.ADMIN,
    isFilespaceAdmin: data.role === MemberRole.FILESPACE_ADMIN,
    isCollaborator: data.role === MemberRole.COLLABORATOR,
    isGuest: data.role === MemberRole.GUEST,
    isServiceAccount: data.role === MemberRole.SERVICE_ADMIN ||
        data.role === MemberRole.SERVICE_COLLABORATOR,
    isActive: data.status === MemberStatus.ACTIVE &&
        data.scimStatus !== MemberScimStatus.DEACTIVATED,
    isPending: data.status === MemberStatus.PENDING,
    isDeactivated: data.status === MemberStatus.DEACTIVATED ||
        data.scimStatus === MemberScimStatus.DEACTIVATED,
    isScimDeactivated: data.scimStatus === MemberScimStatus.DEACTIVATED,
    isLucidManaged: data.provider === PrincipalProvider.LUCID,
});
export const toMemberViewModels = (data) => data.map(toMemberViewModel);
